import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order 390",
  "use": "icon-order 390-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-order 390\"><path d=\"M298.667 192h42.666v63.979l-42.666 0.021v533.333h426.666V256h-42.666v-64h42.666a64 64 0 0 1 64 64v533.333a64 64 0 0 1-64 64H298.667a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64z m256 341.333v64h-192v-64h192z m106.666-128v64H362.667v-64h298.666zM576 128a64 64 0 0 1 64 64v42.667a64 64 0 0 1-64 64H448a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64h128z m0 64H448v42.667h128V192z\" p-id=\"25343\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol